import * as React from 'react';

const SadFace48 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 48 48", width: 48, height: 48, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M19.373 18.91a2.313 2.313 0 1 1-4.626 0 2.313 2.313 0 0 1 4.627 0Zm13.88 0a2.313 2.313 0 1 1-4.626 0 2.313 2.313 0 0 1 4.626 0M13.929 32.758a1.25 1.25 0 0 0 1.71-.411l.003-.006a4 4 0 0 1 .32-.392c.26-.282.687-.68 1.32-1.087 1.254-.806 3.374-1.68 6.718-1.68s5.472.874 6.735 1.681a6.9 6.9 0 0 1 1.331 1.09 4 4 0 0 1 .323.393l.005.007a1.25 1.25 0 0 0 2.125-1.318l-.002-.002-.002-.003v.001l-.003-.006v.001l-.007-.012.001.002-.016-.025.002.003.014.022.002.002.001.002.004.006-.003-.005-.013-.02-.036-.055a6.5 6.5 0 0 0-.564-.696 9.4 9.4 0 0 0-1.816-1.493c-1.675-1.071-4.273-2.075-8.081-2.075s-6.4 1.004-8.07 2.076a9.3 9.3 0 0 0-1.806 1.496 6.5 6.5 0 0 0-.56.698l-.036.055-.013.02-.005.008-.002.003v.001l-.002.002a1.25 1.25 0 0 0 .423 1.717"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M43.003 23.999c0 10.495-8.508 19.003-19.003 19.003S4.997 34.494 4.997 23.999 13.505 4.996 24 4.996s19.003 8.508 19.003 19.003M24 40.502c9.114 0 16.503-7.389 16.503-16.503S33.114 7.496 24 7.496 7.497 14.885 7.497 24 14.886 40.502 24 40.502"
  }
));
SadFace48.Size = 48;
SadFace48.Title = "SadFace";

export { SadFace48 as default };
